//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.FeatureGeometry.js";
let d=[[[0,"Name",1,0],[0,"Status",0,0],[0,"Type",0,0]],[[["num_features"],"GetFeatures",{R_:{features:"CAM.CAMFeature[]"}},0,0],[["num_operations"],"GetOperations",{R_:{operations:"CAM.Operation[]"}},0,0],[["feature"],"AddFeature",{},1,0],[["feature"],"RemoveFeature",{},1,0],[[],"Redistribute",{},0,0]],[]];
SPLM.CAM.FeatureGeometryGroup = class extends SPLM.CAM.FeatureGeometry{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.FeatureGeometryGroup";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.FeatureGeometryGroup.ProcessStatus = Object.freeze({
    "Unknown" : "Unknown", "Ok" : "Ok", "Suspect" : "Suspect"});

export default SPLM;